import request from '../request';

const getOptions = (dealer) => ({
  method: 'GET',
  headers: {
    Authorization: `Bearer ${dealer}`,
  },
});

const getPostOptions = (payload, dealer, method = 'POST') => ({
  method,
  headers: {
    Authorization: `Bearer ${dealer}`,
  },
  body: payload ? JSON.stringify(payload) : undefined,
});

export default {
  getCars: (dealer, payload) =>
    request(`/cars/filtered/`, getPostOptions(payload, dealer, 'POST')),
  getCar: (dealer, vin) => request(`/cars/${vin}`, getOptions(dealer)),
};
